module.exports = {
  login: 'Einloggen um Gutscheine anzuzeigen',
  vouchersTitle: 'Gutscheine',
  bookNow: 'Neue Buchung mit Gutschein',
  voucherLookup:'Gutschein prüfen',
  voucherRefunded: 'Rückerstattet',
  voucherExpired: 'Abgelaufen',
  emailAddress: 'Email Adresse',
  ref: 'Buchungs-/Gutschein Nummer',
  lookUp: 'suchen',
  noVoucher: 'Es wurde kein aktiver Gutschein gefunden, bitte die Angaben prüfen und erneut versuchen.',
  requestRefund: 'Eine Rückerstattung beantragen',
  headings: {
    voucher: 'Gutschein',
    booking: 'Buchung',
    total: 'Gesamtbetrag',
    redeemed: 'Eingelöst',
    balance: 'Betrag',
    created: 'Erstellt am',
    expiry: 'Ablaufdatum',
    nonFlex: 'Flexibel?*'
  },
  types: {
    active: 'Aktive',
    redeemed: 'Eingelöst',
    refunded: 'Rückerstattet',
    expired: 'Abgelaufen'
  },
  vouchersFor: 'Gutscheine für',
  noVouchersFound: 'Leider wurden keine Gutscheine gefunden',
  requestRefund: 'Erstattung des Gutscheins beantragen',
  fullRefundStartFragment: 'Wenn du deinen Gutschein in eine Rückerstattung umwandelst, werden dir',
  fullRefundEndFragment: '€ innerhalb von 5 Tagen auf dein Zahlungsmittel zurückgezahlt.',
  refundMyCard: 'Rückerstattung erhalten',
  keepMyVoucher: 'Gutschein behalten',
  keepMyVoucherForFullAmount: 'Gutschein in voller Höhe behalten',
  fee: '€ Gebühr erhalten',
  refundMyCardLess: 'Rückerstattung abzüglich',
  partialRefundFramentOne: 'Wenn du deinen Gutschein in eine Rückerstattung umwandelst, werden dir',
  partialRefundFragmentTwo: '€ innerhalb von 5 Tagen auf dein Zahlungsmittel zurückgezahlt. Dabei fällt eine Bearbeitungsgebühr in Höhe von',
  partialRefundFragmentThree:  '€ an. Diese werden dir als Gutschrift in deinem Kundenkonto hinterlegt. Damit kannst du sie dir für eine andere Buchung anrechnen lassen.',
  noRefundvoucher: 'Dein Gutschein kann nur innerhalb von 14 Tagen nach der Stornierung in eine Rückerstattung umgewandelt werden. Dein Gutschein bleibt für alle neuen Buchungen innerhalb der nächsten drei Jahre gültig.',
  backToMyVouchers: 'Zurück zu meinen Gutsheinen',
  noRefundRedeemed: 'Dein Gutschein kann nicht in eine Rückerstattung umgewandelt werden, da du bereits einen Teil davon genutzt hast. Der restliche Gutscheinbetrag bleibt natürlich gültig, sodass du ihn für eine andere Buchungen einlösen kannst.',
  nonFlexNoRefund: 'Dein Gutschein kann nicht gegen eine Rückerstattung eingetauscht werden, da du kein flexibles Produkt gebucht hast. Deinen Gutschein kannst du für eine neue Buchung für dasselbe Produkt verwenden.',
  refundingYourVoucher: 'Erstattung des Gutscheins',
  balance: 'Betrag',
  successRefund: 'Der Gutschein wurde erstattet. Die Auszahlung kann bis zu 5 Werktage dauern.',
  errorRefund: 'Entschuldigung! Der Gutschein kann nicht erstattet werden.',
  waitFiveDays: 'Die Auszahlung kann bis zu 5 Werktage dauern.',
  voucherBenefits: 'Der Holiday Extras Gutschein bietet dir viele Vorteile:',
  benefitOne: 'Dein Gutschein ist bis zu 3 Jahre gültig - so bleibt genügend Zeit für deine Urlaubsplanung.',
  benefitTwo: 'Du kannst den Gutschein für viele Holiday Extras Produkte einlösen - gönne dir z.B. eine Lounge oder eine Hotelübernachtung am Flughafen.',
  benefitThree: 'Zusätzlich erhältst du einen exklusiven Mitgliederrabatt auf unsere Parken, Hotel und Lounge Angebote.'
}



// WEBPACK FOOTER //
// ./shared/config/components/vouchers/de/index.js